import { render } from "./ReturnParcelListItem.vue?vue&type=template&id=7100b892&ts=true"
import script from "./ReturnParcelListItem.vue?vue&type=script&lang=ts"
export * from "./ReturnParcelListItem.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__